import {FieldEvent} from './settings';
import {Text} from '../../common/fields/text';
import {fieldArts as arts} from '../../artjs/field';



export function createTEXT(d) {
  FieldEvent[d.fieldName] = new Text(d);
  FieldEvent[d.fieldName].sendCallback = (o) => {
    const m = FieldEvent[d.fieldName];
    m.sendbtn = document.querySelector(`.j-send-${d.fieldName}`);
    m.sendbtn.disabled = m.sendCodeJson.disabled;
    m.sendbtn.value = m.sendCodeJson.time === 0 ? '发送验证码' : m.sendCodeJson.time + '秒';
  };

  return FieldEvent[d.fieldName];
}

export function renderTEXT(d) {
  const field = FieldEvent[d];
  if (!field.dom) {
    field.dom = document.getElementById(`sk-field-${d}`);
  }
  const activeElem = document.activeElement;
  if (field.dom) {
    field.dom.innerHTML = arts[field.displayType == 1 ? 'FIELDTEXT' : 'FIELDTEXTAREA'].pc({field: field});
  }

  if(activeElem&& activeElem.dataset && activeElem.dataset.actid){
    const dom = document.querySelector(activeElem.dataset.actid);
    if(dom){
      dom.focus();
      moveToEnd(dom);
    }
  }
}

export function changeTEXT(e, d) {
  const field = FieldEvent[d];
  field.setValue(e.value);
  const n = field.isSendSms == 1 ? 300 : 0;
  setTimeout(() => {
    renderTEXT(d);
  }, n);
}

export function sendCode(that, name, type) {
  FieldEvent[name].sendCode(type);
  renderTEXT(name);
}

export function sendCodeInput(that, name) {
  FieldEvent[name].setCode(that.value);
  setTimeout(() => {
    renderTEXT(name);
  }, 0);
}

function moveToEnd(selector) {
  var value = selector.value;
  if(selector.setSelectionRange) {
    selector.setSelectionRange(value.length, value.length); //Chrome, Firefox
  } else {
    //IE8
    var range = selector.createTextRange();
    range.collapse(true);
    range.moveStart("character", value.length);
    range.moveEnd("character", 0);
    range.select();
  }
}
